import { Card } from '@components/Card/Card.styled';
import { applyTheme } from '@components/NewCard/NewCard.styled';
import { TitleProps } from '@components/types';
import styled from 'styled-components';

export const CardWrapper = styled(Card)`
    border-radius: 4px;
    background-color: ${({ theme: { colors } }) => colors.pureWhite};
    min-height: auto;
    width: 100%;
    min-width: fit-content;

    ${({ themeType }) => themeType && applyTheme(themeType)}

    @media screen and (max-width: 425px) {
        justify-content: center;
        &:not(:last-child) {
            margin-bottom: 0;
        }
    }
`;

export const Title = styled.div`
    color: ${({ theme: { colors } }) => colors.cyanDarkBlue};
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 21px;
    margin-bottom: 5px;
`;

export const TitleWithIcon = styled(Title)<TitleProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
        transition: transform 200ms ease-out 0s;
        transform: rotate(${({ isActive }) => (isActive ? '180deg' : '0deg')});
    }
`;

export const CardContetWrapper = styled.div`
    margin-top: 15px;
`;

export const PayOffWrapper = styled.div`
    margin-top: 3px;
`;
